import React from 'react'
import { useTranslation } from 'react-i18next'
import { type ActivationKey } from '../license-lookup.types'

type Props = {
    akey: ActivationKey
}

export default function ({akey}: Props) {
    const { t } = useTranslation(['account', 'common']);
    const [showSupportedVersions, setShowSupportedVersions] = React.useState(false);
    const supportedVersionDialog = React.useRef<HTMLDialogElement>(null)
    const supportedVersionToggle = React.useRef<HTMLAnchorElement>(null);

    const openVersionsDialog = (e: React.MouseEvent<HTMLAnchorElement>) => {
        
        e.preventDefault();
        setShowSupportedVersions(true);
    }

    //This is a huge portion of this file dedicated to a tiny box.
    //Would love to clean this up at some point.
    React.useEffect(() => {
        const checkBox = (event: MouseEvent) => {
            const clickedElement = event.target;
            if (clickedElement instanceof Element){
                if (supportedVersionToggle.current.contains(clickedElement)){
                    return;
                }
            }
            if (clickedElement instanceof Element){
                if (!supportedVersionDialog.current.contains(clickedElement)) {
                    setShowSupportedVersions(false);
                }
            }
        }

        const handleEscape = (event: KeyboardEvent) => {
            if (event.key == "Escape"){
                setShowSupportedVersions(false);
            }
        }

        if (showSupportedVersions){
            document.addEventListener('click', checkBox);
            document.addEventListener('keydown', handleEscape);
        }
        else{
            document.removeEventListener('click', checkBox);
            document.removeEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('click', checkBox);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [showSupportedVersions])

    if (!akey){
        return <></>
    }

    const prodCount = akey.supportedVersions.length;

    let versionContent = <></>

    if (prodCount > 1){
        const prodItems: React.JSX.Element[] | React.JSX.Element = [];
        akey.supportedVersions.forEach((p: string) => {
            prodItems.push(
                <li>{p}</li>
            )
        })
        versionContent = (
            <>
            <a ref={supportedVersionToggle} id="version-toggle" href="#" onClick={openVersionsDialog}>{t('license.productCount', {count: prodCount, ns: 'common'})}</a>
            {showSupportedVersions}
            <dialog ref={supportedVersionDialog} open={showSupportedVersions} className='akey-supported-versions box'>
                <ul>
                    {prodItems}
                </ul>
            </dialog>
            </>
        )
    }
    else if (prodCount == 1){
        versionContent = (
            <>{akey.supportedVersions[0]}</>
        )
    }

    const licTypeKey = akey.floating ? 'floating' : 'nodelocked';
    const exp = akey.licenseEndDate || t('license.permLic', {ns: 'common'});

  return (
    <div className='akey-details box'>
        <h2 className='akey-lookup-h2'>{t('license.details', {ns: 'common'})}</h2>
        <div className='akey-details-content'>
            <label>{t('license.akey', {ns: 'common'})}</label>
            <span>{akey.serial}</span>

            <label>{t('license.product', {ns: 'common'})}</label>
            <span>{akey.family} - {akey.host}</span>
            
            <label>{t('license.expDate', {ns: 'common'})}</label>
            <span>{exp}</span>
            
            <label>{t('license.supportedVersions', {ns: 'common'})}</label>
            <span>{versionContent}</span>

            <label>{t('license.quantity', {ns: 'common'})}</label>
            <span>{akey.seatCount}</span>

            <label>{t('license.licType', {ns: 'common'})}</label>
            <span>{t('license.types.' + licTypeKey, {ns: 'common'})}</span>

            {akey.contractEndDate && (
                <>
                <label>{t('license.supportExp', {ns: 'common'})}</label>
                <span>{akey.contractEndDate}</span>
                </>
            )}

            <label>{t('license.versionNum', {ns: 'common'})}</label>
            <span>{akey.versionNumber}</span>
        </div>
    </div>
  )
}